import {faTrophy} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';
import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {appRoute} from '../../../../app-route';
import {CompetitorsPage} from '../../../../page/main/reviews-analysis/pages/competitors-page/competitors-page';
import {useDomainConfig} from '../../../../provider/domain-config/domain-config-hook';
import {DomainNameEnum} from '../../../../provider/domain-config/domain-config-type';
import {useLicenses} from '../../../../provider/license/license-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {useUser} from '../../../../provider/user/user-hook';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {
    getMenuItemNameForAnalytics,
    isEnabledForDomainAndDoubleGisWhiteLabel,
} from '../../../navigation/navigation-helper';
import {NavigationItemConfigType} from '../routing-type';

import {useLocalPackNavigation} from './use-local-pack-navigation';

export function useCompetitorsNavigation(): Array<NavigationItemConfigType> {
    const {licenses, availableFeatures, enabledFeatures} = useLicenses();
    const {search} = useLocation();
    const {getLocalizedString} = useLocale();

    const {domainName} = useDomainConfig();
    const {isReputationManager} = useUser();

    const isLocalPackAvailable = useMemo(() => {
        return (
            isEnabledForDomainAndDoubleGisWhiteLabel({
                isDomainFeatureEnabled: availableFeatures[FeaturesEnum.localPack] || false,
                isFeatureEnabled: Boolean(licenses[FeaturesEnum.localPack]?.isActive),
                domainName,
            }) &&
            !isReputationManager &&
            enabledFeatures.includes(FeaturesEnum.localPack)
        );
    }, [availableFeatures, licenses, enabledFeatures, domainName, isReputationManager]);

    const localPackRoutes = useLocalPackNavigation(isLocalPackAvailable);

    return [
        {
            isAvailable:
                (availableFeatures[FeaturesEnum.reviewAnalyticsCompetitor] &&
                    enabledFeatures.includes(FeaturesEnum.reviewAnalyticsCompetitor)) ||
                isLocalPackAvailable,
            path: appRoute.competitors.path,
            icon: <FontAwesomeIcon icon={faTrophy} />,
            label: getLocalizedString('CATEGORY_NAME__COMPETITORS'),
            [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__COMPETITORS'),
            search,
            redirectPath: appRoute.competitorsDashboard.path,
            deniedPath: [appRoute.competitors.path],
            children: [
                {
                    exact: true,
                    isAvailable:
                        domainName === DomainNameEnum.rocketData &&
                        availableFeatures[FeaturesEnum.reviewAnalyticsCompetitor],
                    isActivated: true,
                    path: appRoute.competitorsDashboard.path,
                    label: getLocalizedString('CATEGORY_NAME__COMPETITORS__DASHBOARD'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__COMPETITORS__DASHBOARD'),
                    component: CompetitorsPage,
                },
                ...localPackRoutes,
            ],
        },
    ];
}
